<fa-icon [icon]="faArrowCircleLeft"></fa-icon>
<span>{{ 'APP.BACK' | translate }}</span>
